import { Module, MutationTree } from 'vuex';

export const errorsModule: Module<any, any> = {
    namespaced: true,
    state: () => ({
        errorMessage: '',
    }),
    mutations: {
        SET_ERROR(state, error: string | Error) {
            const message =
                error instanceof Error ? error.message : String(error);
            console.error('API Error:', message);
            state.errorMessage = message;
        },
        RESET_ERROR_MESSAGE(state) {
            state.errorMessage = '';
        },
    } as MutationTree<any>,
};
